"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const tslib_1 = require("tslib");
const htmlExport = tslib_1.__importStar(require("./export-html"));
const htmlImport = tslib_1.__importStar(require("./import-html"));
const mdExport = tslib_1.__importStar(require("./export-markdown"));
const mdImport = tslib_1.__importStar(require("./import-markdown"));
const PeritextDataTransfer_1 = require("./PeritextDataTransfer");
const create = (txt, registry) => {
    const transfer = new PeritextDataTransfer_1.PeritextDataTransfer(txt, {
        htmlExport,
        htmlImport,
        mdExport,
        mdImport,
    }, registry);
    return transfer;
};
exports.create = create;
